import { SuspenseErrorBoundary } from '@/components/SuspenseErrorBoundary';
import classnames from 'classnames/bind';
import { FC, memo } from 'react';
import { usePaymentDetail } from '../context/PaymentDetailContext';
import { LeftContent } from './LeftContent';
import { RightContent } from './RightContent';
import styles from './styles.module.scss';

const cx = classnames.bind(styles);

type DrawerDetailProps = {
  id: string;
  onClose: () => void;
};

const InnerDetails: FC<DrawerDetailProps> = ({ id, onClose }) => {
  const { isRightPaneCollapsed } = usePaymentDetail();

  return (
    <div className={cx('detail', { 'collapsed-right': isRightPaneCollapsed })}>
      <LeftContent id={id} onClose={onClose} />
      <RightContent reportId={id} />
    </div>
  );
};

export const PaymentDetail: FC<DrawerDetailProps> = memo((props) => {
  return (
    <SuspenseErrorBoundary {...props} onClose={props.onClose}>
      <InnerDetails {...props} />
    </SuspenseErrorBoundary>
  );
});

PaymentDetail.displayName = 'PaymentDetail';
